/* ============================================================
   TIROIR PANIER — Cheese Squishy
   Le balisage est rendu par snippets/cart-drawer.liquid : tous les
   libelles et montants viennent du serveur. Ce script ne fait que
   trois choses : fermer, changer une quantite, remplacer le contenu
   par la section fraichement rendue.
   ============================================================ */
(function () {
  'use strict';

  var ROOT = '#CartDrawer';
  var attente = Object.create(null); /* cle de ligne -> quantite visee */
  var minuteur = null;
  var enVol = false;
  var reprendreFocus = null;

  function tiroir() { return document.querySelector('cart-drawer'); }
  function boite() { return document.getElementById('CartDrawer'); }

  function sections() {
    var d = tiroir();
    if (d && typeof d.getSectionsToRender === 'function') {
      try {
        return d.getSectionsToRender().map(function (s) { return s.id; });
      } catch (e) { /* on retombe sur la liste par defaut */ }
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function ligne(cle) {
    var b = boite();
    if (!b) return null;
    var toutes = b.querySelectorAll('[data-cs-line]');
    for (var i = 0; i < toutes.length; i++) {
      if (toutes[i].getAttribute('data-cs-line') === cle) return toutes[i];
    }
    return null;
  }

  /* --- remplacement du contenu apres une reponse du panier --- */
  function peindre(data) {
    var d = tiroir();
    var cible = boite();
    var html = null;

    if (data && data.sections) {
      html = data.sections['cart-drawer'];
      if (!html) {
        var cles = Object.keys(data.sections);
        for (var i = 0; i < cles.length; i++) {
          if (cles[i].indexOf('cart-drawer') !== -1) { html = data.sections[cles[i]]; break; }
        }
      }
    }

    if (html && cible) {
      var neuf = new DOMParser().parseFromString(html, 'text/html').querySelector(ROOT);
      if (neuf) cible.innerHTML = neuf.innerHTML;
    }

    if (d && typeof data.item_count === 'number') {
      d.classList.toggle('cs-cd--empty', data.item_count === 0);
    }
    if (d && typeof d.updateCartIconBubble === 'function') {
      try { d.updateCartIconBubble(data); } catch (e) {}
    }

    if (reprendreFocus) {
      var li = ligne(reprendreFocus.cle);
      var btn = li && li.querySelector('[data-cs-q="' + reprendreFocus.sens + '"]');
      if (btn) btn.focus();
      reprendreFocus = null;
    }

    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  /* --- envoi d un changement de quantite --- */
  function envoyer(cle, qte) {
    enVol = true;
    var li = ligne(cle);
    if (li) li.classList.add('is-busy');

    var fini = function () {
      enVol = false;
      if (Object.keys(attente).length) vider();
    };

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root + 'cart/change.js'
            : '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: cle,
        quantity: qte,
        sections: sections(),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { if (!r.ok) throw new Error('cart/change ' + r.status); return r.json(); })
      .then(function (data) { peindre(data); fini(); })
      .catch(function () {
        /* on ne laisse jamais une ligne grisee : on recharge l etat reel */
        if (li) li.classList.remove('is-busy');
        rafraichir();
        fini();
      });
  }

  function vider() {
    minuteur = null;
    if (enVol) return;
    var cles = Object.keys(attente);
    if (!cles.length) return;
    var cle = cles[0];
    var qte = attente[cle];
    delete attente[cle];
    envoyer(cle, qte);
  }

  function programmer(cle, qte) {
    attente[cle] = qte;
    if (minuteur) clearTimeout(minuteur);
    minuteur = setTimeout(vider, 260);
  }

  /* --- rechargement complet du tiroir (repli en cas d erreur) --- */
  function rafraichir() {
    var url = window.location.pathname + '?sections=' + sections().join(',');
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (secs) {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (panier) { peindre({ sections: secs, item_count: panier.item_count }); });
      })
      .catch(function () {});
  }

  /* --- interactions, deleguees pour survivre aux re-rendus --- */
  document.addEventListener('click', function (e) {
    /* le voile : le theme le branche dans son constructeur, mais ce lien se
       perd selon l ordre de definition de l element. On le branche ici aussi,
       en delegation, donc il survit a tous les re-rendus. */
    if (e.target && e.target.id === 'CartDrawer-Overlay') {
      var dv = tiroir();
      if (dv && dv.close && dv.classList.contains('open') && !dv.__csferme) {
        dv.__csferme = 1;
        setTimeout(function () { dv.__csferme = 0; }, 500);
        dv.close();
      }
      return;
    }

    var fermer = e.target.closest && e.target.closest('[data-cs-cd-close]');
    if (fermer) {
      e.preventDefault();
      var d = tiroir();
      if (d && d.close) d.close();
      return;
    }

    var pas = e.target.closest && e.target.closest('[data-cs-q]');
    if (!pas || !boite() || !boite().contains(pas)) return;

    e.preventDefault();
    var li = pas.closest('[data-cs-line]');
    var champ = li && li.querySelector('[data-cs-qin]');
    if (!li || !champ) return;

    var sens = parseInt(pas.getAttribute('data-cs-q'), 10);
    var cle = li.getAttribute('data-cs-line');
    var actuelle = attente[cle] !== undefined ? attente[cle] : parseInt(champ.value, 10);
    if (isNaN(actuelle)) actuelle = 1;

    var visee = Math.max(0, actuelle + sens);
    champ.value = visee;                       /* retour visuel immediat */
    reprendreFocus = { cle: cle, sens: sens };
    programmer(cle, visee);
  });

  function commettre(champ) {
    var li = champ.closest('[data-cs-line]');
    if (!li) return;
    var qte = parseInt(champ.value, 10);
    if (isNaN(qte) || qte < 0) qte = 0;
    champ.value = qte;
    reprendreFocus = null;
    programmer(li.getAttribute('data-cs-line'), qte);
  }

  document.addEventListener('change', function (e) {
    var champ = e.target.closest && e.target.closest('[data-cs-qin]');
    if (champ && boite() && boite().contains(champ)) commettre(champ);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var champ = e.target.closest && e.target.closest('[data-cs-qin]');
    if (champ && boite() && boite().contains(champ)) { e.preventDefault(); commettre(champ); }
  });

  /* on expose le peintre : l ajout au panier (cs-home.js) s en sert aussi */
  window.csCartPaint = peindre;

  /* --- filet de securite d ouverture ---
     Le theme anime le panneau avec Motion : il pose d abord un style en
     ligne (opacity:0 ; translateX(100%)) puis anime vers l etat visible.
     Si cette animation ne se joue pas (moteur absent, onglet en arriere
     plan, image gelee), le panneau resterait invisible hors de l ecran.
     700 ms apres l ouverture, on verifie et on retablit l etat visible. */
  function veiller() {
    var d = tiroir();
    if (!d || d.__csveille) return;
    d.__csveille = 1;

    var controle = function () {
      if (!d.classList.contains('open')) return;
      var p = d.querySelector('[data-drawer-content]');
      if (!p) return;
      clearTimeout(d.__cstimer);
      d.__cstimer = setTimeout(function () {
        if (!d.classList.contains('open')) return;
        var st = getComputedStyle(p);
        var pose = st.transform === 'none' || st.transform === 'matrix(1, 0, 0, 1, 0, 0)';
        if (st.opacity === '1' && pose) return;
        try { p.getAnimations().forEach(function (a) { a.finish(); }); } catch (e) {}
        p.style.opacity = '';
        p.style.transform = '';
      }, 700);
    };

    if (window.MutationObserver) {
      new MutationObserver(controle).observe(d, { attributes: true, attributeFilter: ['class'] });
    }
    controle();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', veiller);
  else veiller();
  document.addEventListener('shopify:section:load', veiller);
})();
